// extracted by mini-css-extract-plugin
export default {"issue":"IssueItem_issue__XXarL","fadeUp":"IssueItem_fadeUp__Y1ri+","issueData":"IssueItem_issueData__+Uzts","issueInfo":"IssueItem_issueInfo__at1S+","stick":"IssueItem_stick__X-AbZ"};